import React, { Component } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import {
  Redirect,
  Link,
} from 'react-router-dom';
import { Form, Control, actions } from 'react-redux-form';
import MaskedInput from 'react-text-mask';
import NotificationList from '../Notifications';
import logo from '../../assets/images/logo.svg';
import { baseLoginPath } from '../Forms/Schemas/baseRrf';
import InputField from '../Forms/Controls/Field';
import { validateEmail } from '../Forms/Validators';
import Button from '../Button';
import NewOpenedAccountBanner from '../NewOpenedAccountBanner';

import {
  loginWithEmailPassphrase,
  fetchAccounts,
  fetchUser,
  setAccreditation,
} from '../../actions';
import {
  addNotification,
} from '../../actions/notifications';
import { isAccredited } from '../../helpers';
import './index.css';
import imgWarning from '../../assets/images/warning.svg';
import blueCheck from '../../assets/images/blue_confirmation_check.png';

const fields = [
  {
    model: '.email',
    RRFComp: Control.text,
    control: {
      type: 'email',
      placeholder: 'Email',
      errors: {
        required: val => !val || !val.length,
        isEmail: val => val && !validateEmail(val),
      },
      disabled: false,
    },
    error: {
      messages: {
        required: 'Please enter your email',
      },
    },
  }, {
    model: '.passphrase',
    RRFComp: Control.text,
    control: {
      type: 'password',
      placeholder: 'Password',
      errors: {
        required: val => !val || !val.length,
      },
    },
    error: {
      messages: {
        required: 'Please enter your password',
      },
    },
  }, {
    model: '.ssn',
    RRFComp: Control,
    control: {
      component: MaskedInput,
      mask: [/\d/, /\d/, /\d/, /\d/],
      guide: false,
      placeholder: 'Last 4-Digits of SSN',
      maxLength: 4,
      style: {
        width: '100%',
        border: 'none',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: '#706e6e',
      },
      errors: {
        required: val => !val || !val.length,
        isLengthFour: val => val && !(val.length === 4),
      },
    },
    error: {
      messages: {
        required: 'Last four digits of your SSN are required',
        isLengthFour: 'Please enter all last four digits of your SSN',
      },
    },
  },
];


export class UnconnectedLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      authError: false,
      showSsnField: false,
      accountLocked: false,
      ssnVerified: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit = async () => {
    if (this.state.submitting) {
      return;
    }
    const formData = this.props.loginForm;
    if (formData) {
      const { email, passphrase, ssn } = formData;
      if (!email || !passphrase) {
        this.setState({ authError: true });
        return;
      }
      this.setState({
        submitting: true,
        showSsnField: false,
        authError: false,
      });
      try {
        const loginResponse = await this.props.loginWithEmailPassphrase(email, passphrase, ssn);
        await this.props.resetSsn();
        if (loginResponse === 'ssn-required') {
          this.setState({
            showSsnField: true,
            submitting: false,
          });
          return;
        }
        if (loginResponse === 'redirect-to-reset-password') {
          this.setState({ ssnVerified: true, showSsnField: false });
          return;
        }
        await this.props.fetchAccounts();
        const { finances } = await this.props.fetchUser();
        if (finances) {
          const { annualIncome, totalNetWorth } = finances;
          isAccredited(annualIncome, totalNetWorth, (flag) => {
            this.props.setAccreditation(flag);
          });
        }
        return;
      } catch (err) {
        await this.props.resetSsn();
        if (err.message === 'Unauthorized') {
          this.setState({ authError: true, showSsnField: false });
        }
        if (err.message === 'Account Locked') {
          this.setState({ accountLocked: true, showSsnField: false });
        }
        // this.props.addNotification(`Login error: ${err.message}`);
      }
    }
    this.setState({ submitting: false });
  };

  render() {
    const { authToken, authTokenUser, currentAccount } = this.props;
    const { next = '/portfolio' } = (this.props.location && this.props.location.state) || {};

    if (authToken && currentAccount) {
      return (<Redirect to={next} />);
    }
    if (authTokenUser && !authTokenUser.signUpCompleted) {
      return (<Redirect to="/sign-up" />);
    }
    let content = (
      <div styleName="Login">
        <NotificationList />
        <Link to="/">
          <img
            src={logo}
            alt="My IPO"
            styleName="logo"
          />
        </Link>
        <div styleName="body">
          <div styleName="newOpenedAccountBannerContainer">
            <MediaQuery maxWidth="624px">
              <NewOpenedAccountBanner isMobile />
            </MediaQuery>
            <MediaQuery minWidth="625px">
              <NewOpenedAccountBanner />
            </MediaQuery>
          </div>

          <Form
            model={baseLoginPath}
            onSubmit={this.onSubmit}
            className={this.state.submitting ? 'submitting' : ''}
          >
            <div styleName="loginFieldContainer">
              {fields.map((field) => {
                if (field.model === '.ssn' && !this.state.showSsnField) {
                  return '';
                }
                if (field.model === '.email') {
                  if (this.state.showSsnField) {
                    field.control.disabled = true; // eslint-disable-line
                  } else {
                    field.control.disabled = false; // eslint-disable-line
                  }
                }
                return (
                  <InputField
                    key={field.model}
                    fieldProps={field}
                  />
                );
              })}
              {this.state.authError && this.props.passphraseValid && (
                <div styleName="authError">Invalid email or password</div>
              )}
              {this.state.showSsnField && (
                <div styleName="ssnCheckError">
                  You have tried to login multiple times to your account with an incorrect password. To verify it is you,
                  please enter the <span styleName="bold"> last 4-digits</span> of your Social Security Number (`SSN`).
                  Please note that if the SSN entered does not match with your account, then your account will be locked
                  for security purposes.
                </div>
              )}
              <Link
                styleName="forgotPwdLink"
                to="/forgot-pass"
              >
                Forgot your password?
              </Link>
            </div>
            <div styleName="submitButtonContainer">
              <Button
                disabled={this.state.submitting}
                type="submit"
              >
                {this.state.submitting ? 'Logging in...' : 'Log in'}
              </Button>
            </div>
          </Form>
          <div styleName="noAccount">
            Don&apos;t have an account&#63;&nbsp;
            <Link
              to={{ pathname: 'https://www.myipo.com/register' }}
              target="_blank"
              styleName="signUpLink"
            >
              Sign up now
            </Link>
          </div>
        </div>
      </div>
    );
    if (this.state.ssnVerified) {
      content = (
        <div styleName="Login">
          <Link to="/">
            <img
              src={logo}
              alt="My IPO"
              styleName="logo"
            />
          </Link>
          <div styleName="alertBody">
            <div styleName="alertRow">
              <img src={blueCheck} alt="Warning" styleName="alertImg" style={{ width: 120, height: 120 }} />
            </div>
            <div styleName="alertRow">
              <div styleName="alertBlue">
                SSN verified successfully
              </div>
            </div>
            <div styleName="alertRow">
              <div styleName="alertMessage">
                It appears you forgot your password associated with your account. Please check your email inbox with
                details on how to reset your password.
              </div>
            </div>
            <div styleName="alertRow">
              <div styleName="alertMessage">
                Should you have any questions, please feel free to contact&nbsp;
                <a styleName="alertLink" href="mailto:clientservices@myipo.com">
                  clientservices@myipo.com
                </a>
                &nbsp;for further details.&nbsp;
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.accountLocked) {
      content = (
        <div styleName="Login">
          <Link to="/">
            <img
              src={logo}
              alt="My IPO"
              styleName="logo"
            />
          </Link>
          <div styleName="alertBody">
            <div styleName="alertRow">
              <img src={imgWarning} alt="Warning" styleName="alertImg" style={{ width: 120, height: 120 }} />
            </div>
            <div styleName="alertRow">
              <div styleName="alertRed">
                Account Locked
              </div>
            </div>
            <div styleName="alertRow">
              <div styleName="alertMessage">
                To unlock your account please contact&nbsp;
                <a styleName="alertLink" href="mailto:clientservices@myipo.com">
                  clientservices@myipo.com
                </a>
                &nbsp;for further details.&nbsp;
              </div>
            </div>
          </div>
        </div>
      );
    }
    return content;
  }
}


const mapStateToProps = state => ({
  currentAccount: state.currentAccount,
  authToken: state.authToken,
  authTokenUser: state.authTokenUser,
  loginForm: state.loginForm,
  passphraseValid: state.loginForm.forms.passphrase.valid,
});

const mapDispatchToProps = dispatch => ({
  setAccreditation: (...args) => (dispatch(setAccreditation(...args))),
  loginWithEmailPassphrase: (...args) => (dispatch(loginWithEmailPassphrase(...args))),
  fetchAccounts: (...args) => (dispatch(fetchAccounts(...args))),
  fetchUser: (...args) => (dispatch(fetchUser(...args))),
  addNotification: (...args) => (dispatch(addNotification(...args))),
  resetSsn: () => (dispatch(actions.reset(`${baseLoginPath}.ssn`))),
});


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedLogin);



// WEBPACK FOOTER //
// ./src/components/Login/index.js